module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "mshow": _vm.show
    }
  }, [_c('validate', {
    on: {
      "verified": _vm.onVerified,
      "cancel": _vm.onCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c933b62"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/plugins/login/validate.vue
// module id = 121
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 14 15 16 17 18 20 21 22 23 25 26 29 30 31 32 34 35 36 38 41 42 43 45 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63